// extracted by mini-css-extract-plugin
export default {"root":"badge_root__zbIy6","rootTypeLocalsDate":"badge_rootTypeLocalsDate__fcKZr","rootJustLovebirds":"badge_rootJustLovebirds__rBJyl"};